import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-df42c85e")

_pushScopeId("data-v-df42c85e")
const _hoisted_1 = {
  key: 0,
  id: "chart-doughnut"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["canvas-frame", { 'opacity-0': !_ctx.renderCanvasElement }]
  }, [
    (_ctx.renderCanvasElement)
      ? (_openBlock(), _createBlock("canvas", _hoisted_1))
      : _createCommentVNode("", true)
  ], 2))
})